/**
 * A deadline spelled out for a person: `Saturday, September 19, 2026, 2:05 PM
 * (Central Daylight Time)`.
 *
 * Every place that tells someone when a temporary password stops working —
 * the email that carries it, the sign-in refusal after it has expired, and
 * the administrator's reveal dialog — prints the instant this way, in the
 * dealership's zone (`DEALERSHIP_TIMEZONE`), with the zone named in full so
 * "2:05 PM" is never ambiguous on a phone in another state. Instants are
 * stored in UTC; this is presentation only, shared by the server and the
 * client so the words match wherever the person reads them.
 */
export function formatDeadline(at: Date, timeZone: string): string {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZoneName: "long",
  }).formatToParts(at);
  const part = (type: Intl.DateTimeFormatPartTypes): string =>
    parts.find((candidate) => candidate.type === type)?.value ?? "";
  return (
    `${part("weekday")}, ${part("month")} ${part("day")}, ${part("year")}, ` +
    `${part("hour")}:${part("minute")} ${part("dayPeriod")} (${part("timeZoneName")})`
  );
}
